import z from 'zod';

export const MessageCategorySchema = z.enum([
  'Activity',
  'Marketing',
  'Status',
]);

export const MessageTypeSchema = z.enum([
  'Cash',
  'Bonus',
  'Coins',
  'CommunityJackpot',
  'DailyGift',
  'Free Spins',
  'InstantWheel',
  'Level',
  'LadderProgress',
  'Wheel',
  'Scratcher',
  'Status',
]);

export const CtaTypeSchema = z.enum([
  'RedeemLoyaltyReward',
  'RedeemCommunityEventReward',
  'NavigationShop',
  'NavigationRewards',
  'NavigationGames',
  'NavigationGameLaunch',
  'NavigationPromotions',
  'NavigationQuests',
  'NavigationTransmit',
]);

export const CtaSchema = z.object({
  type: CtaTypeSchema,
  text: z.string(),
  details: z.string().optional(),
  isClicked: z.boolean(),
});

export const InboxMessageResponseSchema = z.object({
  id: z.number(),
  category: MessageCategorySchema,
  type: MessageTypeSchema.optional(),
  isRead: z.boolean(),
  cta: CtaSchema,
  createdAt: z.string().datetime().optional(),
  title: z.string(),
  body: z.string(),
  imageUrl: z.string().url().optional(),
});

export const InboxResponseSchema = z.array(InboxMessageResponseSchema);
